import React from "react";
import { IoIosCloseCircleOutline } from "react-icons/io";

const FormHeader = ({ toggleForm }) => (
  <div className="flex justify-between items-center mb-4">
    <h2 className="text-lg font-medium text-gray-900">Add a plan</h2>
    <button
      onClick={toggleForm}
      className="text-gray-500 hover:text-gray-700 focus:outline-none"
    >
      <IoIosCloseCircleOutline size={20} />
    </button>
  </div>
);

export default FormHeader; 